import { getAdminAuthHeaders } from './adminApi';

const API_BASE_URL = process.env.REACT_APP_GOTTEA_API_BASE_URL || 'https://gottea-search-5gtrn.ondigitalocean.app';

async function getAuthHeaders() {
  return getAdminAuthHeaders();
}

async function parseResponse(response) {
  const body = await response.json().catch(() => ({}));
  if (!response.ok || body.success === false) {
    throw new Error(body.error || body.message || `Request failed with status ${response.status}`);
  }
  return body.data || body;
}

async function request(path, options = {}) {
  const authHeaders = await getAuthHeaders();
  const response = await fetch(`${API_BASE_URL}${path}`, {
    ...options,
    headers: {
      ...authHeaders,
      'Content-Type': 'application/json',
      ...(options.headers || {}),
    },
  });
  return parseResponse(response);
}

export async function fetchTestOtpNumbers() {
  const data = await request('/auth/admin/test-otp-numbers');
  return data.testOtpNumbers || [];
}

export async function createTestOtpNumber(payload) {
  const data = await request('/auth/admin/test-otp-numbers', {
    method: 'POST',
    body: JSON.stringify(payload),
  });
  return data.testOtpNumber;
}

export async function updateTestOtpNumber(phoneNumber, payload) {
  const data = await request(`/auth/admin/test-otp-numbers/${encodeURIComponent(phoneNumber)}`, {
    method: 'PUT',
    body: JSON.stringify(payload),
  });
  return data.testOtpNumber;
}

export async function deleteTestOtpNumber(phoneNumber) {
  return request(`/auth/admin/test-otp-numbers/${encodeURIComponent(phoneNumber)}`, {
    method: 'DELETE',
  });
}
